mutation ApproveImport2FullMigration($input: ImportAcceptSponsorshipInput!) {
    import2AcceptSponsorship(input: $input) {
        isSuccess
    }
}
